import { useSelector } from 'react-redux';
import { getAuthenticated } from 'store/state/session/sessionSelectors';

export const useAuth = () => {
  const isAuthenticated = useSelector(getAuthenticated);
  return {
    isAuthenticated,
  };
};
